export * from './RelatorioServiceAdapter'